module.exports = __webpack_public_path__ + "static/profile500-f223851cba4979a27196c33636edabd9.jpg";